import { Component, Input } from '@angular/core';
import { WebsocketService } from '../../services/websocket.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { JobsActions } from '../../store/jobs/jobs.actions';
import { WsUpdateTaskMessage } from '../../models/ws-update-task-message.model';
import { ResponsiveService } from '../../services/reponsive.service';
import { Observable } from 'rxjs';
import { routeTransition } from '../../route-transition';
import { SideBarComponent } from "../../components/side-bar/side-bar.component";
import { ClientActions } from '../../store/client/client.actions';


@Component({
  selector: 'app-dashboard',
  imports: [RouterOutlet, SideBarComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  animations: [routeTransition]
})
export class DashboardComponent {
  @Input() open: boolean = false;

  // Responsives
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  constructor(
    private websocketService: WebsocketService,
    private store: Store,
    private responsiveService: ResponsiveService,
    protected route: ActivatedRoute
  ) {
    this.store.dispatch(ClientActions.loadClient());
    this.store.dispatch(JobsActions.loadJobs())
    this.websocketService.messages$.subscribe((wsUpdateTaskMessage: any) => {
      if(wsUpdateTaskMessage.plan) this.store.dispatch(ClientActions.setPlan({ plan: wsUpdateTaskMessage.plan }));
      this.store.dispatch(JobsActions.updateJobFromWsMessage({ wsUpdateTaskMessage }))
    });
  }
}
